<h1 mat-dialog-title>Otros turnos</h1>
<div class="table-scroll">
  <table class="table-content">
    <tr>
      <th class="cell-date">Fecha</th>
      <th class="cell-date">Práctica</th>
      <th class="cell-date">Centro</th>
      <th class="cell-date">Estado</th>
      <th class="cell-date"></th>
    </tr>

    <tr *ngFor="let item of data">
      <td class="cell-date">{{ item.DateTime }}</td>
      <td class="cell-date">{{ item.PrincipalPracticeName }}</td>
      <td class="cell-date">{{ item.CenterName }}</td>
      <td class="cell-date">{{ item.StateName }}</td>
      <td class="cell-date">
        <button
          mat-flat-button
          color="primary"
          type="button"
          (click)="audit(item)"
        >
          Auditar
        </button>
      </td>
    </tr>
  </table>
</div>
<div class="clearfix">
  <div class="pull-right">
    <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">
      Salir
    </button>
  </div>
</div>
